import { Card, CardContent, Stack, Box, Typography, Divider } from "@mui/material"
import { CreateInvoiceForm } from ".."

// --- InvoiceHeader Component ---
const InvoiceHeader = ({ invoiceData }: { invoiceData: CreateInvoiceForm }) => (
  <Card variant="outlined" sx={{ mb: 3, background: "#f8fafc" }}>
    <CardContent>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center" alignItems="center">
        <Box>
          <Typography variant="h6" fontWeight={700} align="center" color="primary.main">
            {invoiceData?.clientName}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", sm: "block" } }} />
        <Stack spacing={0.5} alignItems="left">
          <Typography fontSize={13} color="text.secondary">
            <strong>Port: </strong> {invoiceData?.paymentContainerParams?.port?.label}
          </Typography>
          <Typography fontSize={13} color="text.secondary">
            <strong>Vendor: </strong>
            {invoiceData?.paymentContainerParams?.vendor?.label}
          </Typography>
          <Typography fontSize={13} color="text.secondary">
            <strong>Description: </strong>
            {invoiceData?.paymentContainerParams?.description?.label}
          </Typography>
          <Typography fontSize={14} color="text.secondary">
            <strong>Container Type: </strong> {invoiceData?.paymentContainerParams?.containerType?.label}
          </Typography>
        </Stack>
      </Stack>
    </CardContent>
  </Card>
)

export default InvoiceHeader
